import VSelectCourseColumn from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseColumn', VSelectCourseColumn),
};
